<template>
  <!-- print-root: lo que SÍ queremos imprimir -->
  <div class="page-content almacen-page print-root">
    <div class="almacen-wrapper">
      <div class="almacen-card">
        <!-- Barra superior (solo pantalla) -->
        <header class="entrada-header no-print">
          <div>
            <p class="almacen-title">
              Detalle de orden de entrada
            </p>
            <p class="almacen-subtitle">
              Vista compacta y lista para impresión.
            </p>
          </div>

          <div class="entrada-header__actions">
            <button
              type="button"
              class="ios-ghost-button"
              @click="volverListado"
            >
              ← Volver al listado
            </button>
            <button
              type="button"
              class="ios-primary-button"
              @click="imprimir"
            >
              🖨 Imprimir
            </button>
          </div>
        </header>

        <section v-if="cargando" class="entrada-hint">
          Cargando orden de entrada...
        </section>

        <section v-else-if="!orden" class="entrada-hint">
          No se encontró la orden de entrada.
        </section>

        <!-- DETALLE ORDEN / FORMATO COMPACTO -->
        <section v-else class="orden-detalle">
          <!-- Encabezado tipo ficha -->
          <div class="orden-header-simple">
            <div class="orden-header-col">
              <div class="orden-header-row">
                <span class="orden-header-label">Orden de entrada</span>
                <span class="orden-header-value orden-header-strong">
                  {{ orden.folio || 'SIN FOLIO' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Fecha</span>
                <span class="orden-header-value">
                  {{ formatearFecha(orden.fecha) }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Proveedor</span>
                <span class="orden-header-value">
                  {{ orden.proveedor || '—' }}
                </span>
              </div>
            </div>

            <div class="orden-header-col">
              <div class="orden-header-row">
                <span class="orden-header-label">Dirección recepción</span>
                <span class="orden-header-value">
                  {{ orden.direccion_recepcion || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Solicitó</span>
                <span class="orden-header-value">
                  {{ orden.solicito || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Entregó</span>
                <span class="orden-header-value">
                  {{ orden.entrego || '—' }}
                </span>
              </div>
              <div class="orden-header-row">
                <span class="orden-header-label">Recibió</span>
                <span class="orden-header-value">
                  {{ orden.recibio || '—' }}
                </span>
              </div>
            </div>
          </div>

          <div
            v-if="orden.comentarios"
            class="orden-comentarios-simple"
          >
            <span class="orden-header-label">Comentarios generales</span>
            <p class="orden-header-value">
              {{ orden.comentarios }}
            </p>
          </div>

          <!-- Productos / items -->
          <div class="orden-items">
            <div
              v-for="(item, index) in orden.items"
              :key="index"
              class="orden-item-block"
            >
              <!-- Encabezado del producto -->
              <div class="orden-item-header-row">
                <div class="orden-item-titulo">
                  <span class="orden-item-index">
                    Producto #{{ index + 1 }}
                  </span>
                  <span class="orden-item-nombre">
                    {{ item.producto?.nombre || 'Producto' }}
                  </span>
                  <span
                    v-if="item.es_nuevo_producto"
                    class="orden-item-nuevo"
                  >
                    (nuevo)
                  </span>
                </div>
                <div class="orden-item-cantidad">
                  Cantidad: <strong>{{ item.cantidad }}</strong>
                </div>
              </div>

              <div
                v-if="item.producto?.descripcion || item.comentarios"
                class="orden-item-descripcion-row"
              >
                <p v-if="item.producto?.descripcion">
                  <strong>Descripción:</strong>
                  {{ item.producto.descripcion }}
                </p>
                <p v-if="item.comentarios">
                  <strong>Comentarios:</strong>
                  {{ item.comentarios }}
                </p>
              </div>

              <!-- Tabla compacta por producto -->
              <div class="orden-items-table">
                <table>
                  <thead>
                    <tr>
                      <th style="width: 45px;">Unidad</th>
                      <th style="width: 90px;">Tipo</th>
                      <th>Producto</th>
                      <th style="width: 180px;">Número de serie</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Sin unidades -->
                    <tr
                      v-if="!item.unidades || !item.unidades.length"
                    >
                      <td colspan="4" class="orden-items-table-empty">
                        No se registraron series para este producto.
                      </td>
                    </tr>

                    <!-- Unidades + complementos (listado plano) -->
                    <template
                      v-else
                      v-for="(u, uIndex) in item.unidades"
                      :key="u.id_unidad || uIndex"
                    >
                      <!-- Fila principal -->
                      <tr>
                        <td class="orden-items-table-center">
                          {{ uIndex + 1 }}
                        </td>
                        <td>Principal</td>
                        <td>
                          {{ item.producto?.nombre || 'Producto' }}
                        </td>
                        <td>
                          {{ u.numero_serie || '—' }}
                        </td>
                      </tr>

                      <!-- Filas de complementos de esta unidad -->
                      <tr
                        v-for="(uc, cIndex) in (u.complementos || [])"
                        :key="(uc.id_unidad || (uIndex + '-' + cIndex))"
                      >
                        <td class="orden-items-table-center">
                          {{ uIndex + 1 }}
                        </td>
                        <td>Complemento</td>
                        <td>
                          {{ uc.producto?.nombre || 'Complemento' }}
                        </td>
                        <td>
                          {{ uc.numero_serie || '—' }}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'VerOrdenEntrada',
  data() {
    return {
      orden: null,
      cargando: false,
    };
  },
  mounted() {
    this.cargarOrden();
  },
  methods: {
    async cargarOrden() {
      const id = this.$route.params.id;
      if (!id) return;

      this.cargando = true;
      try {
        const res = await axios.get('/api/almacen/ordenes-entrada/ver/' + id);
        if (res.data?.status === 'ok' && res.data.orden) {
          this.orden = res.data.orden;
        } else {
          this.orden = null;
        }
      } catch (error) {
        console.error('Error al cargar detalle de orden de entrada:', error);
        this.$toast?.error('No se pudo cargar el detalle de la orden de entrada.');
        this.orden = null;
      } finally {
        this.cargando = false;
      }
    },
    formatearFecha(f) {
      if (!f) return '—';
      const [y, m, d] = f.split('-');
      if (!y || !m || !d) return f;
      return `${d}/${m}/${y}`;
    },
    imprimir() {
      window.print();
    },
    volverListado() {
      this.$router.push({ name: 'DashboardOrdenesEntrada' });
    },
  },
};
</script>

<style scoped>
.almacen-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.almacen-wrapper {
  width: 100%;
  max-width: 1100px;
}

.almacen-card {
  border-radius: 1.4rem;
  padding: 1.2rem 1.1rem 1rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.96)
    );
  backdrop-filter: blur(22px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow:
    0 16px 40px rgba(15, 23, 42, 0.9),
    0 0 0 1px rgba(15, 23, 42, 0.85);
}

.almacen-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #e5e7eb;
}

.almacen-subtitle {
  font-size: 0.78rem;
  color: #94a3b8;
}

/* Header (solo pantalla) */
.entrada-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
}

.entrada-header__actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

/* Hints */
.entrada-hint {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* CONTENEDOR DETALLE */
.orden-detalle {
  border-radius: 1rem;
  border: 1px solid rgba(148, 163, 184, 0.55);
  background: rgba(15, 23, 42, 0.96);
  padding: 0.7rem 0.7rem 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  font-size: 0.78rem;
  color: #e5e7eb;
}

/* Encabezado tipo "datos" */
.orden-header-simple {
  display: grid;
  grid-template-columns: 1.1fr 1.5fr;
  gap: 0.6rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.45);
  padding-bottom: 0.35rem;
}

.orden-header-col {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.orden-header-row {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 0.25rem;
}

.orden-header-label {
  font-weight: 500;
  color: #cbd5f5;
}

.orden-header-value {
  color: #e5e7eb;
  word-break: break-word;
}

.orden-header-strong {
  font-size: 0.86rem;
}

.orden-comentarios-simple {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 0.25rem;
}

/* Productos / items */
.orden-items {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.orden-item-block {
  border-radius: 0.7rem;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: rgba(15, 23, 42, 0.98);
  padding: 0.45rem 0.45rem 0.45rem;
}

.orden-item-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
}

.orden-item-titulo {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
  flex-wrap: wrap;
}

.orden-item-index {
  font-weight: 600;
}

.orden-item-nombre {
  font-weight: 500;
}

.orden-item-nuevo {
  font-size: 0.75em;
  font-style: italic;
}

.orden-item-cantidad {
  white-space: nowrap;
}

.orden-item-descripcion-row {
  margin-top: 0.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  color: #cbd5f5;
}

/* Tabla compacta */
.orden-items-table {
  margin-top: 0.3rem;
}

.orden-items-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.76rem;
}

.orden-items-table th,
.orden-items-table td {
  border: 1px solid rgba(148, 163, 184, 0.6);
  padding: 0.16rem 0.3rem;
  vertical-align: top;
}

.orden-items-table th {
  text-align: left;
  font-weight: 600;
  background: rgba(15, 23, 42, 0.96);
}

.orden-items-table-center {
  text-align: center;
}

.orden-items-table-empty {
  text-align: center;
  font-style: italic;
  color: #94a3b8;
}

/* Botones iOS */
.ios-primary-button,
.ios-ghost-button {
  border-radius: 999px;
  padding: 0.42rem 0.9rem;
  font-size: 0.78rem;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease,
    box-shadow 0.16s ease;
}

.ios-primary-button {
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.7),
    rgba(37, 99, 235, 1)
  );
  border-color: rgba(129, 140, 248, 0.9);
  color: #e5e7eb;
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.7);
}

.ios-primary-button:hover {
  transform: translateY(-0.5px);
  box-shadow: 0 16px 32px rgba(37, 99, 235, 0.9);
}

.ios-ghost-button {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.7);
  color: #e5e7eb;
}

.ios-ghost-button:hover {
  background: rgba(15, 23, 42, 1);
}

/* Responsive */
@media (max-width: 768px) {
  .entrada-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .orden-header-simple {
    grid-template-columns: 1fr;
  }

  .orden-header-row,
  .orden-comentarios-simple {
    grid-template-columns: 110px 1fr;
  }

  .orden-item-header-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
